import React from 'react';
import Avatar from '@material-ui/core/Avatar'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { userSignOut } from 'actions/Auth';
import IntlMessages from 'util/IntlMessages';

class UserInfo extends React.Component {

  state = {
    anchorEl: null,
    open: false,
    AuthUser: this.props.authUser,
    success: this.props.success
  };

  handleClick = event => {
    this.setState({ open: true, anchorEl: event.currentTarget });
  };

  componentDidMount() {
    //console.log(this.props)
  }
  handleRequestClose = () => {
    this.setState({ open: false });
  };
  RoleSwitch(param) {
    switch (param) {
      case 0:
        return <IntlMessages id="user.Role.SAdmin" />
      case 1:
        return <IntlMessages id="user.Role.Admin" />;
      case 2:
        return <IntlMessages id="user.Role.Backoffice" />;
      case 3:
        return <IntlMessages id="user.Role.User" />;
      case 4:
        return <IntlMessages id="user.Role.Meetingbooker" />;
      case 5:
        return <IntlMessages id="user.Role.Orderhandler" />;
      default:
        return <IntlMessages id="user.Role.Admin" />;
    }
  }
  render() {
    const { user_Afid, user_Email, user_Notification, user_SeeCasesList, user_SeeContractFlag, user_SeeDialer,
      user_SeeEndClients, user_SeeOrderList, user_SeeRinglist, user_WeekNotification, user_fnamn, user_lnamn, user_role, user_id } = this.state.AuthUser;
    return (
      <div className="user-profile d-flex flex-row align-items-center">
        <Link to={
          parseInt(user_role) === 5?"/app/Order":"/app/Lobby"
        }>
          <Avatar className=" size-40 text-white"
            src={require("assets/images/Loggavit.png")}
            >
          </Avatar>
        </Link>
        <div className="user-detail pl-4">
          <h4 className="user-name" onClick={this.handleClick}> {user_fnamn} {user_lnamn} <i
            className="zmdi zmdi-caret-down zmdi-hc-fw align-middle" />
          </h4>
          <h5 className="user-name">
            {this.RoleSwitch(user_role)}
          </h5>
        </div>
        <Menu className="user-info"
          id="simple-menu"
          anchorEl={this.state.anchorEl}
          open={this.state.open}
          onClose={this.handleRequestClose}
          PaperProps={{
            style: {
              minWidth: 120,
              paddingTop: 0,
              paddingBottom: 0
            }
          }}
        >
          <MenuItem onClick={this.handleRequestClose}>
            <Link className="text-muted" to={'/app/profile/' + user_id}>
              <i className="zmdi zmdi-account zmdi-hc-fw mr-2" />
              <IntlMessages id="popup.profile" />
            </Link>
          </MenuItem>
          <MenuItem className="text-muted" onClick={() => {
            this.handleRequestClose();
            this.props.userSignOut()
          }}>
            <i className="zmdi zmdi-sign-in zmdi-hc-fw mr-2" />

            <IntlMessages id="popup.logout" />
          </MenuItem>
        </Menu>
      </div>
    );
  }
}

const mapStateToProps = ({ settings, auth }) => {
  const { locale } = settings;
  const { authUser, token, success } = auth;
  return { locale, authUser, token, success }
};
export default connect(mapStateToProps, { userSignOut })(UserInfo);


